import type { ReactNode } from 'react';
import { ProgressBar } from './progressBar';

type Props = {
  label: ReactNode;
  value: ReactNode;
  barPercent: number;
  barColor: string;
};

export function ProgressItem({ label, value, barPercent, barColor }: Props) {
  return (
    <div>
      <div className="flex items-baseline justify-between mb-[7px]">
        <span className="text-base text-gray-500 font-medium">{label}</span>
        <span className="text-base">{value}</span>
      </div>
      <ProgressBar percent={barPercent} color={barColor} />
    </div>
  );
}
